type Project = {
  title: string;
  label: string;
  description: string;
  website?: string;
  caseStudy?: string;
  github?: string;
  info: string;
  techStack: string[];
  features: string[];
};

export default [
  // {
  //   title: "Flick",
  //   label: "Actively working on it",
  //   description:
  //     "Your all-in-one solution to organize, track, and share links.",
  //   website: "https://tryflick.vercel.app",
  //   github: "https://github.com/dhvanitmonpara/flick",
  //   techStack: [
  //     "React",
  //     "Node.js",
  //     "TypeScript",
  //     "TailwindCSS",
  //     "zustand",
  //     "Express",
  //     "ShadcnUI",
  //     "Cloudinary",
  //     "MongoDB",
  //     "Redis",
  //     "Socket.io",
  //     "JWT",
  //   ],
  // },
  {
    title: "Interview.AI",
    label: "Hackathon Project",
    description:
      "An AI-powered interview platform with live video, face expression tracking, and real-time coding evaluation.",
    github: "https://github.com/dhvanitmonpara/interview.ai",
    info: "Interview.AI is your ultimate solution for conducting AI-powered technical interviews. It features live webcam support, real-time face expression tracking, and automated coding assessments. The platform ensures a seamless experience for interviewers and candidates, providing insightful analytics on performance and engagement. With built-in face detection, emotion analysis, and code execution powered by Judge0, Interview.AI streamlines the hiring process for tech teams and recruiters. Conduct fair, data-driven, and efficient interviews like never before!",
    techStack: [
      "TypeScript",
      "React",
      "Node.js",
      "Zustand",
      "Socket.IO",
      "Clerk",
      "Zod",
      "MongoDB",
      "Monaco Editor",
      "Face-api.js",
      "Judge0 API",
      "Ready Player Me",
      "Recharts",
      "ShadCN UI",
    ],
  },
  {
    title: "OS-Themed Portfolio",
    description: "My personal portfolio but Operating System themed.",
    website: "https://dhvanitmonpara.vercel.app/os",
    github: "https://dhvanitmonpara.vercel.app/os/source-code",
    info: "A personal portfolio designed to mimic an operating system interface, featuring interactive windows, real-time updates, and a seamless user experience.",
    techStack: [
      "React",
      "Node.js",
      "TypeScript",
      "Tailwind CSS",
      "ShadCN UI",
      "Zustand",
      "Socket.io",
    ],
  },
  {
    title: "True Feedback",
    description: "Get anonymous feedback with ease.",
    website: "https://truefeedback-next.vercel.app",
    github: "https://github.com/dhvanitmonpara/true-feedback",
    info: "True Feedback allows users to receive completely anonymous feedback. Whether it's for self-improvement, workplace reviews, or fun anonymous confessions, this platform ensures privacy and honesty in communication. Built with security in mind, it provides an intuitive UI and seamless experience.",
    techStack: [
      "NextJS",
      "TypeScript",
      "TailwindCSS",
      "ShadcnUI",
      "NextAuth",
      "MongoDB",
      "Vercel's AI SDK",
      "zod",
    ],
  },
  {
    title: "GujjuScript",
    description: "A fun programming language with Gujarati-inspired keywords.",
    website: "https://www.npmjs.com/package/gujjuscript",
    github: "https://github.com/dhvanitmonpara/gujjuscript",
    info: "GujjuScript is a playful yet insightful programming language featuring Gujarati-inspired keywords. Built as a fun experiment, it offers a unique way to explore compiler design, lexers, parsers, and language syntax while celebrating regional culture.",
    techStack: ["Node.js"],
  },
  {
    title: "Rapid Express CLI",
    description:
      "A CLI tool that simplifies Express.js project setup by automating configurations and reducing boilerplate.",
    website: "https://www.npmjs.com/package/rapid-express-cli",
    github: "https://github.com/dhvanitmonpara/rapid-express-cli",
    info: "Rapid Express CLI automates the setup of Express.js projects with database integration, Socket.IO support, TypeScript compatibility, PM2, Docker, and a clean file structure. Designed to speed up development with an interactive configuration process.",
    techStack: [
      "Node.js",
      "Inquirer",
      "Express.js",
      "TypeScript",
      "JavaScript",
      "Docker",
      "PM2",
    ],
  },
  {
    title: "Music Academy",
    description: "A learning project for Acertinity UI and Next.js.",
    website: "https://next-musicacademy.vercel.app",
    github: "https://github.com/dhvanitmonpara/music-academy",
    info: "Music Academy is an educational project aimed at learning and experimenting with Acertinity UI and Next.js. It showcases a interactive landing page with animations powered with aceternity ui.",
    techStack: ["NextJS", "TypeScript", "TailwindCSS", "Acertinity UI"],
  },
  {
    title: "Incognito Chat",
    description: "Chat anonymously without worrying about privacy.",
    website: "https://incognitochat.vercel.app",
    github: "https://github.com/dhvanitmonpara/incognito-chat",
    info: "Incognito Chat is an anonymous chat platform that allows users to communicate securely without revealing their identity. It leverages encryption and a minimalistic design to provide a seamless and private chatting experience.",
    techStack: [
      "React",
      "Node.js",
      "TypeScript",
      "TailwindCSS",
      "Socket.io",
      "Express",
      "zustand",
    ],
  },
  {
    title: "Video Caller",
    label: "Not deployed",
    description: "A simple video calling app using WebRTC.",
    github: "https://github.com/dhvanitmonpara/webrtc-video-caller",
    info: "Video Caller is a real-time video calling application built using WebRTC. It allows users to connect and communicate with low-latency video streaming, making it ideal for quick, peer-to-peer video conversations.",
    techStack: ["Node.js", "WebRTC", "Socket.io"],
  },
  {
    title: "Proof of Concept for video Streams",
    label: "Not deployed",
    description: "Implemented video streaming using Socket.io and FFmpeg.",
    github: "https://github.com/dhvanitmonpara/video-streams",
    info: "Video Streams is a project that enables real-time video streaming using Socket.io and FFmpeg. It demonstrates how to process and transmit video efficiently across networks, making it useful for live streaming applications.",
    techStack: ["Node.js", "FFmpeg", "video.js"],
  },
] as Project[];
